import moment from "moment";
import "moment/min/locales";

export const months = () => {
  moment.locale("pt-br");
  return moment.months();
};

export const currMonth = () => {
  return moment().months();
};

export const years = () => {
  let diff = moment()
    .subtract(10, "years")
    .format("YYYY");

  const curr = moment().format("YYYY");

  let years = [];

  for (var i = curr; i >= diff; i--) {
    years.push(i);
  }

  return years;
};

export const states = [
  { nome: "Acre", sigla: "AC" },
  { nome: "Alagoas", sigla: "AL" },
  { nome: "Amapá", sigla: "AP" },
  { nome: "Amazonas", sigla: "AM" },
  { nome: "Bahia", sigla: "BA" },
  { nome: "Ceará", sigla: "CE" },
  { nome: "Distrito Federal", sigla: "DF" },
  { nome: "Espírito Santo", sigla: "ES" },
  { nome: "Goiás", sigla: "GO" },
  { nome: "Maranhão", sigla: "MA" },
  { nome: "Mato Grosso", sigla: "MT" },
  { nome: "Mato Grosso do Sul", sigla: "MS" },
  { nome: "Minas Gerais", sigla: "MG" },
  { nome: "Pará", sigla: "PA" },
  { nome: "Paraíba", sigla: "PB" },
  { nome: "Paraná", sigla: "PR" },
  { nome: "Pernambuco", sigla: "PE" },
  { nome: "Piauí", sigla: "PI" },
  { nome: "Rio de Janeiro", sigla: "RJ" },
  { nome: "Rio Grande do Norte", sigla: "RN" },
  { nome: "Rio Grande do Sul", sigla: "RS" },
  { nome: "Rondônia", sigla: "RO" },
  { nome: "Roraima", sigla: "RR" },
  { nome: "Santa Catarina", sigla: "SC" },
  { nome: "São Paulo", sigla: "SP" },
  { nome: "Sergipe", sigla: "SE" },
  { nome: "Tocantins", sigla: "TO" }
];

export const placeholders = {
  estado: "Estado",
  setor: "Setor",
  funcao: "Função",
  funcaoOutros: "Outra função",
  nome: "Nome",
  dataNascimento: "Data Nascimento",
  cpf: "CPF",
  rg: "RG",
  telefone: "Telefone",
  email: "E-mail",
  pais: "País",
  cidade: "Cidade",
  bairro: "Bairro",
  endereço: "Endereço",
  numero: "Número",
  complemento: "Complemento"
};

export const LabelButtons = {
  cancelar: "Cancelar",
  sair: "Sair",
  cadastrar: "Cadastrar",
  excluir: "Excluir",
  enviar: "Enviar",
  salvar: "Salvar"
};

export const EmployeeStatus = {
  EnvioDeDocumentos: 1,
  AprovaçãoDeDocumentos: 2,
  DocumentosRejeitados: 3,
  PendenteDeIntegração: 4,
  Habilitado: 5,
  Desativado: 6
};

export const CompanyStatus = {
  SolicitacaoDeCadastro: { id: 1, name: "Solicitação de cadastro" },
  EnvioDeDocumentos: { id: 2, name: "Envio de Documentos" },
  AguardandoAprovacao: {
    id: 3,
    name: "Aguardando Aprovação"
  },
  HabilitadoComPendencias: {
    id: 4,
    name: "Habilitado com Pendências"
  },
  Habilitado: { id: 5, name: "Habilitado" },
  Desativado: { id: 6, name: "Desativado" }
};

export const GeneralStatus = {
  habilitado: "Habilitado",
  desativado: "Desativado",
  cancelado: "Cancelado"
};

export const Functions = {
  SemSetor: 1,
  Controladoria: 2,
  CDI: 3,
  Ambulatorio: 4,
  SegurançaDoTrabalho: 5,
  SegurançaPatrimonial: 6,
  Almoxarifado: 7,
  Recepcao: 8,
  Financeiro: 9,
  Compras: 10,
  Juridico: 11,
  MeioAmbiente: 21
};
